import { StyleRules } from '@material-ui/core/styles';
import { CheckboxClassKey } from '@material-ui/core/Checkbox';

import { core as theme } from '../styles/core';

export const MuiCheckbox: Partial<StyleRules<CheckboxClassKey>> = {
  indeterminate: {
    color: theme.palette.primary.main,
  }
};
